<ng-template #viewLabel></ng-template>
<ng-template #viewValue>
    <audio controls>
        <source [src]="url" type="audio/mpeg" />
        Your browser does not support the audio element.
    </audio>
</ng-template>
